import {Component, Input} from '@angular/core';
import {PopoverController, IonList, IonItem, IonContent} from '@ionic/angular/standalone';

@Component({
    selector: 'app-list-popover',
    templateUrl: './list-popover.component.html',
    styleUrls: ['./list-popover.component.scss'],
    standalone: true,
    imports: [IonContent, IonList, IonItem]
})
export class ListPopoverComponent {

  @Input() items: {id: string, title: string}[];
  @Input() popoverCtrl: PopoverController;

}
